(() => {
  const key = 'glaskob_cart_edit_v1';
  const config = document.querySelector('[data-glass-edit-config]');
  if (!config) return;
  const root = config.dataset.root;
  const copy = JSON.parse(config.textContent);
  const read = () => { try { const state = JSON.parse(sessionStorage.getItem(key)); return state && state.expires > Date.now() ? state : null; } catch { return null; } };
  const clear = () => { try { sessionStorage.removeItem(key); } catch { /* Storage is optional outside edit mode. */ } };
  const json = async (path, body) => {
    const response = await fetch(root + path, body ? {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(body)} : {headers:{'Accept':'application/json'}, cache:'no-store'});
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-glass-edit]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy','true');
    try {
      const cart = await json('cart.js');
      const original = cart.items.find(item => item.key === link.dataset.key);
      if (!original) throw new Error('missing');
      sessionStorage.setItem(key, JSON.stringify({original, baseline:cart.items.map(item=>item.key), expires:Date.now()+15*60*1000}));
      window.location.assign(link.href);
    } catch { link.textContent = copy.startError; link.removeAttribute('aria-busy'); }
  });
  const state = read();
  const area = document.querySelector('[data-glass-edit-area]');
  if (!state || !area || Number(area.dataset.productId) !== state.original.product_id || location.hash !== '#glass-edit') return;
  area.hidden = false;
  const message = area.querySelector('[data-edit-message]');
  const details = area.querySelector('dl');
  for (const [name,value] of Object.entries(state.original.properties || {})) {
    if (name.startsWith('_') || !value) continue;
    const dt = document.createElement('dt'); dt.textContent = name;
    const dd = document.createElement('dd'); dd.textContent = value;
    details.append(dt, dd);
  }
  area.querySelector('[data-edit-cancel]').addEventListener('click', () => clear());
  const normalize = value => value.replace(/\*/g,'').trim().toLocaleLowerCase();
  const restored = new Set();
  const restore = () => {
    document.querySelectorAll('.optionHolder').forEach(holder => {
      const label = holder.querySelector('label.option-label');
      const input = holder.querySelector('input.option-number-input');
      if (!label || !input || restored.has(input.id)) return;
      const property = Object.entries(state.original.properties || {}).find(([name]) => normalize(name) === normalize(label.textContent));
      if (!property) return;
      restored.add(input.id);
      input.value = property[1];
      for (const type of ['input','change','keyup','blur']) input.dispatchEvent(new Event(type,{bubbles:true}));
    });
  };
  const observer = new MutationObserver(restore);
  observer.observe(area.parentElement,{subtree:true,childList:true});
  restore();
  setTimeout(()=>observer.disconnect(),15000);
  document.addEventListener('click', event => {
    if (!event.target.closest('.addToCartCustomButton')) return;
    if (!read() || !area.querySelector('[data-edit-confirm]').checked) {
      event.preventDefault(); event.stopImmediatePropagation();
      message.textContent = read() ? copy.check : copy.startError;
      area.querySelector('[data-edit-confirm]').focus();
    }
  }, true);
  let processing = false;
  document.addEventListener('glaskob:cart-added', async event => {
    if (processing || !read() || !area.querySelector('[data-edit-confirm]').checked) return;
    const added = event.detail?.items || (event.detail?.key ? [event.detail] : []);
    const replacement = added.find(item => item.product_id === state.original.product_id && item.key !== state.original.key && !state.baseline.includes(item.key));
    if (!replacement) { message.textContent = copy.error; return; }
    processing = true; message.textContent = copy.saving;
    try {
      const cart = await json('cart.js');
      const original = cart.items.find(item=>item.key === state.original.key);
      const current = cart.items.find(item=>item.key === replacement.key);
      if (!original || !current || original.quantity !== state.original.quantity || current.quantity !== replacement.quantity) throw new Error('changed');
      // Never remove the original before the replacement exists with the correct quantity.
      if (current.quantity !== original.quantity) await json('cart/change.js',{id:current.key,quantity:original.quantity});
      await json('cart/change.js',{id:original.key,quantity:0});
      clear(); window.location.assign(root+'cart');
    } catch { message.textContent = copy.error; processing = false; }
  });
})();
